export default __webpack_public_path__ + "static/support-img-9fd21c6037cb022dd52455e88c2b25b6.svg";